export default __webpack_public_path__ + "static/media/screenshot2.ca5459da.png";